import {TFunction} from 'i18next';
import {RowData} from '../../base/export-care-plan-group-data-processor';
import {ExportCarePlanData} from '../../base/export-care-plan-types';
import {CommonIadlPdfDataProcessor} from '../export-care-plan-common-iadl-pdf-data';

export class LaundryPdfDataProcessor extends CommonIadlPdfDataProcessor {
  // Inherits the same headers and row structure as Common processor.

  constructor(baseData: ExportCarePlanData, t: TFunction) {
    super(baseData, t);

    this.handleTaskDetailsCellValue = (rowData: RowData) => {
      // TODO: We should get by feature.
      const laundryEntry = rowData.getEntryById('64ed3f1a681190b580f316e9');
      const laundryName = `<b>${laundryEntry?.name ?? 'n/a'}:</b>`;
      const laundryValue = this.getEntryValue(laundryEntry);

      return `${laundryName}\n${laundryValue}`;
    };
  }
}
